import { merge } from '@isyc-react/core/utils';
import { emptyTheme } from "../theme.vm";
import { cssVariables } from "./css-variables";
export const partialToTheme = (partial, root) => {
  const element = root !== null && root !== void 0 ? root : document.documentElement;
  const current = getTheme(element);
  const final = partial ? merge(current, partial) : current;
  return final;
};
export const updateTheme = (theme, root) => {
  const element = root !== null && root !== void 0 ? root : document.documentElement;
  const final = partialToTheme(theme, element);
  cssVariables.forEach(item => {
    item.cssSetter(element, item.themeGetter(final));
  });
  return final;
};
export const removeTheme = root => {
  const element = root !== null && root !== void 0 ? root : document.documentElement;
  cssVariables.forEach(item => item.cssRemove(element));
};
export const getTheme = root => {
  const element = root !== null && root !== void 0 ? root : document.documentElement;
  const theme = emptyTheme();
  cssVariables.forEach(item => {
    item.themeSetter(theme, item.cssGetter(element));
  });
  return theme;
};
export const setTheme = (theme, root) => {
  const element = root !== null && root !== void 0 ? root : document.documentElement;
  cssVariables.forEach(item => {
    item.cssSetter(element, item.themeGetter(theme));
  });
};